module.exports = __webpack_public_path__ + "static/media/coco_spash_animation.d954fb23.gif";